<div class="mb-3">
  <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
    <div class="input-group clockpicker">
      <timepicker [class.form-control]="!gridView" autoClose="false" [formControl]="formControlObj"
        [showMeridian]="bsConfig.showMeridian" [showSpinners]="!gridView">
      </timepicker>
    </div>
  </app-field-title>
</div>